"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseView_1 = require("@/views/BaseView");
var vue_property_decorator_1 = require("vue-property-decorator");
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var Spinner_vue_1 = __importDefault(require("@/components/spinner/Spinner.vue"));
var DefaultUserPhoto_vue_1 = __importDefault(require("@/components/user-photo/default-user-photo/DefaultUserPhoto.vue"));
var TimeLine_vue_1 = __importDefault(require("@/components/time-line/TimeLine.vue"));
var MapRouteExtendedViewer_vue_1 = __importDefault(require("@/components/maps/map-route-extended-viewer/MapRouteExtendedViewer.vue"));
var SimilarFeaturedPartnership_vue_1 = __importDefault(require("@/components/trip/featured-partnership-gallery/similar/SimilarFeaturedPartnership.vue"));
var TripPilgrimJoinRequestAction_vue_1 = __importDefault(require("@/components/trip-pilgrim-join-request-action/TripPilgrimJoinRequestAction.vue"));
var dayjs_1 = __importDefault(require("dayjs"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var TripPilgrimPreview = /** @class */ (function (_super) {
    __extends(TripPilgrimPreview, _super);
    function TripPilgrimPreview() {
        var _this = _super.call(this) || this;
        dayjs_1.default.extend(customParseFormat_1.default);
        _this.isPrivate = false;
        _this.tripPilgrim = null;
        _this.localities = null;
        _this.appearsAsParticipant = false;
        _this.isOwnedByTheCurrentUser = false;
        _this.mapLoading = true;
        return _this;
    }
    TripPilgrimPreview_1 = TripPilgrimPreview;
    TripPilgrimPreview.prototype.mounted = function () {
        var _this = this;
        this.loader = true;
        this.$getTripPilgrimService.request(this.$route.params.tripPilgrimId).then(function (response) {
            _this.tripPilgrim = response;
            _this.checkIsEditable();
            _this.loader = false;
            var routeExtendedRequest = TripPilgrimPreview_1.createLocalitiesRequest(response);
            if (routeExtendedRequest === null) {
                return;
            }
            _this.$getPlanLocalitiesService.requestForPilgrimTrip(routeExtendedRequest).then(function (response) {
                _this.localities = response;
            });
        }, function (error) {
            if (error.response.status === 401) {
                _this.isPrivate = true;
                _this.loader = false;
            }
            else {
                _this.$router.push({ name: 'error', params: { code: error.response.status } });
            }
        });
        this.$root.$on('SESSION_DESTROY_EVENT', function () {
            _this.isOwnedByTheCurrentUser = false;
        });
        this.$root.$on('AUTHENTICATED_EVENT', function () {
            _this.checkIsEditable();
        });
    };
    TripPilgrimPreview.createLocalitiesRequest = function (trip) {
        var _a, _b;
        if (((_a = trip === null || trip === void 0 ? void 0 : trip.partnership) === null || _a === void 0 ? void 0 : _a.slug) && (trip === null || trip === void 0 ? void 0 : trip.route) && (trip === null || trip === void 0 ? void 0 : trip.date_from) && (trip === null || trip === void 0 ? void 0 : trip.date_to) && trip.end_gps_latitude && trip.end_gps_longitude &&
            trip.start_gps_latitude && trip.start_gps_longitude) {
            return {
                traveling_hours_per_day: parameters_1.default.planner.defaultTravelingHoursPerDay,
                plan: {
                    route: trip === null || trip === void 0 ? void 0 : trip.route,
                    transport_id: trip === null || trip === void 0 ? void 0 : trip.transport.id,
                    date_from: dayjs_1.default(trip === null || trip === void 0 ? void 0 : trip.date_from).format('YYYY-MM-DD'),
                    date_to: dayjs_1.default(trip === null || trip === void 0 ? void 0 : trip.date_to).format('YYYY-MM-DD'),
                    end_gps_latitude: trip.end_gps_latitude,
                    end_gps_longitude: trip.end_gps_longitude,
                    start_gps_latitude: trip.start_gps_latitude,
                    start_gps_longitude: trip.start_gps_longitude,
                },
                partnership_slug: (_b = trip === null || trip === void 0 ? void 0 : trip.partnership) === null || _b === void 0 ? void 0 : _b.slug,
                preferences: trip === null || trip === void 0 ? void 0 : trip.preferences
            };
        }
        else {
            return null;
        }
    };
    TripPilgrimPreview.prototype.checkIsEditable = function () {
        var _this = this;
        if (!this.$oAuth2.getSessionId()) {
            return;
        }
        this.$getUserDataService.request().then(function (response) {
            var _a;
            _this.isOwnedByTheCurrentUser = response.id === ((_a = _this.tripPilgrim) === null || _a === void 0 ? void 0 : _a.owner).id;
            _this.userData = response;
            _this.checkAppearsAsParticipant(response);
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    TripPilgrimPreview.prototype.checkAppearsAsParticipant = function (user) {
        var _a;
        if (!((_a = this.tripPilgrim) === null || _a === void 0 ? void 0 : _a.participants)) {
            return;
        }
        for (var _i = 0, _b = this.tripPilgrim.participants; _i < _b.length; _i++) {
            var participant = _b[_i];
            if (participant.id === user.id) {
                this.appearsAsParticipant = true;
                break;
            }
        }
    };
    TripPilgrimPreview.prototype.onShowMapModal = function () {
        this.$refs.MapRouteExtendedViewer.changeSizeContainer();
    };
    TripPilgrimPreview.prototype.transformToPlannerModel = function () {
        if (this.tripPilgrim === null) {
            throw new Error('Trip is null');
        }
        return {
            plan: {
                route: this.tripPilgrim.route,
                transport_id: this.tripPilgrim.transport.id,
                date_from: dayjs_1.default(this.tripPilgrim.date_from).format("YYYY-MM-DD"),
                date_to: dayjs_1.default(this.tripPilgrim.date_to).format("YYYY-MM-DD"),
                start_gps_latitude: this.tripPilgrim.start_gps_latitude,
                start_gps_longitude: this.tripPilgrim.start_gps_longitude,
                end_gps_latitude: this.tripPilgrim.end_gps_latitude,
                end_gps_longitude: this.tripPilgrim.end_gps_longitude
            }
        };
    };
    TripPilgrimPreview.prototype.deleteTrip = function () {
        var _this = this;
        this.loader = true;
        this.$deleteTripPilgrimService.request(this.tripPilgrim).then(function () {
            _this.$router.push({ name: 'userPilgrimTrips' });
        }, function (error) {
            _this.$router.push({ name: 'error', params: { code: error.response.status } });
        });
    };
    TripPilgrimPreview.prototype.deleteParticipantByOwner = function (participant) {
        var _this = this;
        if (!this.tripPilgrim) {
            return;
        }
        this.loader = true;
        this.$deleteParticipantByOwnerService.request(this.tripPilgrim, participant).then(function () {
            _this.deleteParticipantFromLocalData(participant);
            _this.loader = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    TripPilgrimPreview.prototype.deleteParticipantBySelf = function () {
        var _this = this;
        this.loader = true;
        this.$deleteParticipantBySelfService.request(this.tripPilgrim).then(function () {
            var _a;
            _this.appearsAsParticipant = false;
            _this.deleteParticipantFromLocalData(_this.userData);
            if (((_a = _this.tripPilgrim) === null || _a === void 0 ? void 0 : _a.privacy.description) === 'private') {
                _this.$router.push({ name: 'userPilgrimTrips' });
            }
            _this.loader = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    TripPilgrimPreview.prototype.deleteParticipantFromLocalData = function (participant) {
        var _a;
        if (!((_a = this.tripPilgrim) === null || _a === void 0 ? void 0 : _a.participants)) {
            return;
        }
        this.tripPilgrim.participants = this.tripPilgrim.participants.filter(function (tripPilgrimParticipant) {
            return participant.id !== tripPilgrimParticipant.id;
        });
    };
    TripPilgrimPreview.prototype.requestRouteDataForChanges = function () {
        if (this.tripPilgrim == null || this.tripPilgrim.date_from == null || this.tripPilgrim.date_to == null
            || this.tripPilgrim.start_gps_latitude == null || this.tripPilgrim.start_gps_longitude == null
            || this.tripPilgrim.end_gps_latitude == null || this.tripPilgrim.end_gps_longitude == null) {
            return;
        }
    };
    var TripPilgrimPreview_1;
    TripPilgrimPreview = TripPilgrimPreview_1 = __decorate([
        vue_property_decorator_1.Component({
            name: 'TripPilgrimPreview',
            components: {
                ViewWrapper: ViewWrapper_vue_1.default,
                Spinner: Spinner_vue_1.default,
                DefaultUserPhoto: DefaultUserPhoto_vue_1.default,
                TimeLine: TimeLine_vue_1.default,
                MapRouteExtendedViewer: MapRouteExtendedViewer_vue_1.default,
                SimilarFeaturedPartnership: SimilarFeaturedPartnership_vue_1.default,
                TripPilgrimJoinRequestAction: TripPilgrimJoinRequestAction_vue_1.default
            }
        })
    ], TripPilgrimPreview);
    return TripPilgrimPreview;
}(BaseView_1.BaseView));
exports.default = TripPilgrimPreview;
